import type { IconNode } from '../types';

/**
 * @name football
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgM2MtLjgtLjgtMy0xLjItNS44LS45cy02IDEuNi04LjggNC40LTQgNi00LjQgOC44LjEgNSAuOSA1LjggMyAxLjIgNS44LjkgNi0xLjYgOC44LTQuNCA0LTYgNC40LTguOC0uMS01LS45LTUuOCIgLz4KICA8cGF0aCBkPSJNNi40IDE3LjYgOSAxNSIgLz4KICA8cGF0aCBkPSJNOC43IDIxLjljLS44LTMuMy0zLjQtNS44LTYuNy02LjciIC8+CiAgPHBhdGggZD0ibTguMSAxMy45IDIgMiIgLz4KICA8cGF0aCBkPSJtMTEgMTEgMiAyIiAvPgogIDxwYXRoIGQ9Im0xMy45IDguMSAyIDIiIC8+CiAgPHBhdGggZD0iTTE1LjMgMi4xYy44IDMuMyAzLjQgNS44IDYuNiA2LjYiIC8+CiAgPHBhdGggZD0ibTE1IDkgMi42LTIuNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/football
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const football: IconNode = [
  [
    'path',
    {
      d: 'M21 3c-.8-.8-3-1.2-5.8-.9s-6 1.6-8.8 4.4-4 6-4.4 8.8.1 5 .9 5.8 3 1.2 5.8.9 6-1.6 8.8-4.4 4-6 4.4-8.8-.1-5-.9-5.8',
      key: '11cimt',
    },
  ],
  ['path', { d: 'M6.4 17.6 9 15', key: '17ohsz' }],
  ['path', { d: 'M8.7 21.9c-.8-3.3-3.4-5.8-6.7-6.7', key: 'py3vyr' }],
  ['path', { d: 'm8.1 13.9 2 2', key: '18da3y' }],
  ['path', { d: 'm11 11 2 2', key: 'gzk4uv' }],
  ['path', { d: 'm13.9 8.1 2 2', key: '1tyu3t' }],
  ['path', { d: 'M15.3 2.1c.8 3.3 3.4 5.8 6.6 6.6', key: '1j8z1g' }],
  ['path', { d: 'm15 9 2.6-2.6', key: 'szh70n' }],
];

export default football;
